import React from 'react'
import { formatValue } from '../../helpers/funcs'
import Placeholder from '../misc/placeholder'
import { getEntityProjects } from '../../helpers/api'
import ProjectListVertical from './ProjectListVertical'

const ProjectList = (props) => {
    const { Subtitle, stage, ContributorID, signalReady } = props

    const [data, setData] = React.useState(null)

    React.useEffect(() => {
        getEntityProjects(ContributorID)
            .then(data => {
                //console.log("filtering only", stage)
                setData((data || []).filter(p => p.Stage === stage))
                signalReady && signalReady('projects')
            })
    }, [ContributorID])

    return data ? (
        <>
            <section className="section">
                <h3 className="section-header">{props.Title || 'List'}{props.Total && ` (${data ? data.length : 0})`}
                    {Subtitle && (
                        <React.Fragment>
                            <br />
                            <small className="subtitle">{Subtitle}</small>
                        </React.Fragment>
                    )}
                </h3>
                <div className="table-responsive">
                    {data && data.length ? (
                        <table className="table table-striped">
                            <thead className="bg-light">
                                <tr>
                                    <th>Approval<br />Modality</th>
                                    <th>Sector</th>
                                    <th>Latest Stage</th>
                                    <th>Entity(ies)</th>
                                    <th>Theme</th>
                                    <th>Region(s)</th>
                                    <th>Countries</th>
                                    <th className="text-right">GCF<br />Budget (USD)</th>
                                    <th className="text-right">Total<br />Budget (USD)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data ? data.map((d, idx) => (
                                    <React.Fragment key={idx}>
                                        <tr className="bg-silver">
                                            <td className="nowrap"><i className="fas fa-caret-down"></i> {d.ApprovedRef || d.ProjectsID}</td>
                                            <td colSpan="8"><strong>{d.ProjectName}</strong></td>
                                        </tr>
                                        <tr>
                                            <td>{d.ApprovalModality}</td>
                                            <td>{d.Sector}</td>
                                            <td>{d.LatestStage}</td>
                                            <td>{d.EntityList}</td>
                                            <td>{d.Theme}</td>
                                            <td>{d.RegionList}</td>
                                            {/*
                                    <td className="print-none" style={{ width: '150px' }}>{(JSON.parse(d.CountryListDetails || '[]')).map(c => (
                                        <img className="miniflag" key={c.ISO2} src={`https://ipmsapplication.blob.core.windows.net/public/images/flags/24/${c.ISO2.toLowerCase()}.png`} alt={c.CountryName} title={c.CountryName} />
                                    ))}</td>
                                    */}
                                            <td>
                                                <div className="print-none" style={{ maxWidth: '150px' }}>
                                                    {(JSON.parse(d.CountryListDetails || '[]')).map(c => (
                                                        <img className="miniflag" key={c.ISO2} src={`https://ipmsapplication.blob.core.windows.net/public/images/flags/24/${c.ISO2.toLowerCase()}.png`} alt={c.CountryName} title={c.CountryName} />
                                                    ))}
                                                </div>
                                                <span className="print-only">{(JSON.parse(d.CountryListDetails || '[]')).map(c => c.CountryName).join(', ')}</span>
                                            </td>
                                            <td className="text-right nowrap">{formatValue(d.TotalGCFBudgetUSD)}</td>
                                            <td className="text-right nowrap">{formatValue(d.TotalBudgetUSD)}</td>
                                        </tr>
                                    </React.Fragment>
                                )) : null}
                            </tbody>
                            {data && data.length ? (
                                <tfoot>
                                    <tr className="bg-dark color-white">
                                        <td colSpan="7" className="strong">Total</td>
                                        <td className="text-right strong nowrap">{formatValue(data.reduce((acum, item) => {
                                            return acum + item.TotalGCFBudgetUSD
                                        }, 0))}
                                        </td>
                                        <td className="text-right strong nowrap">{formatValue(data.reduce((acum, item) => {
                                            return acum + item.TotalBudgetUSD
                                        }, 0))}
                                        </td>
                                    </tr>
                                </tfoot>
                            ) : null}
                        </table>
                    ) : (
                            <p>No data for this category.</p>
                        )}
                </div>
            </section>
            <div className="d-sm-none">
                <ProjectListVertical data={data && data.filter(p => p.Stage === stage)} Total={true} Title={props.Title || 'List'} Subtitle={Subtitle} />
            </div>
        </>
    ) : <Placeholder />
}

export default ProjectList